import React from 'react';
import PropTypes from 'prop-types';

import { useCombobox } from './ComboboxContext';

const ComboboxList = ({ children }) => {
  const { isOpen, filteredChildren } = useCombobox();

  if (!isOpen) return null;

  const filtered = filteredChildren(children);

  if (filtered.length === 0) return null;

  return (
    <ul className="combobox__list" role="listbox">
      {filtered}
    </ul>
  );
};

ComboboxList.propTypes = {
  children: PropTypes.node,
};

export default ComboboxList;
